// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".travel-history-wrapper{-webkit-box-flex:1;-ms-flex:1;flex:1}", "",{"version":3,"sources":["webpack://./src/components/components/my-travel-history/style.scss"],"names":[],"mappings":"AAAA,wBACE,kBAAA,CAAA,UAAA,CAAA,MAAA","sourcesContent":[".travel-history-wrapper {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
